@if (!message.deletedAt && message.bulkMessageId) {
  <span class="am-flex-align gap-xxs font-s font-500 mt-s">
    <span>Gruppen-Nachricht</span>
    @if (participantName) { <span>({{ participantName }})</span> }
  </span>
}

<div class="am-flex-column gap-xxs lh-m b-radius-wide p-xs relative" #content
    [class.width-250]=" !message.deletedAt && !message.bulkMessageId"
    [class.width-full]="!message.deletedAt &&  message.bulkMessageId"
    [class.mb-m]="      !message.deletedAt &&  message.bulkMessageId"
    [ngClass]="bubbleStyle">
  @if (message.deletedAt) { <span class="font-s color-disabled">Nachricht gelöscht</span> }
  @else {
    <span class="am-flex-justify gap-m am-flex-align-start">
      @if (editMode) {
        <div class="am-flex-column am-flex-align-end gap-s width-full">
          <textarea id="update-box" class="p-s bg-blue b-white color-white-i resize-none overflow" type="text" [(ngModel)]="message.text"></textarea>
          <button class="am-flex-align gap-xs" (click)="edit.emit(message)">
            <span class="am-flex-center font-l icon-send"></span>
            <span class="font-s">Bearbeiten</span>
          </button>
        </div>
      } @else {
        <div class="am-flex-column gap-xs">
          @if (!message.bulkMessageId && showParticipantName()) { <span class="font-s font-500">{{ participantName }}</span> }
          <span class="am-flex-1 word-break-all">{{ message.text }}</span>
        </div>
        @if (chatFullAccess && isOwnMessage(message)) {
          <span class="am-flex-center font-l icon-dots tooltip-icon">
            <div class="web-tooltip top-0 right-0 mt-xxs mr-l white p0 font-s">
              <span class="hover-active pt-xxs pb-xxs pl-xs pr-xs text-center bb-grey" (click)="goEditMode($event)">Bearbeiten</span>
              <span class="hover-active pt-xxs pb-xxs pl-xs pr-xs"                     (click)="confirmDelete(message)">Löschen</span>
            </div>
          </span>
        }
      }
    </span>
    @if (!editMode) {
      <span class="am-flex-align-end gap-xxs font-s mla mta">
        @if (message.editedAt) { <span class="font-xs">(<span>Bearbeitet</span>)</span> }
        <span>{{ message.createdAt | date: 'HH:mm' }}</span>
        @if (isOwnMessage(message)) { <span class="am-flex-center font-l" [ngClass]="messageIsRead(message) ? 'icon-ticks' : 'icon-tick'"></span> }
      </span>
    }
  }
</div>
